<template>
  <div>
    <div class="content-header">
      <div class="left">交易记录</div>
      <div class="right"></div>
      <div class="bottom"></div>
    </div>
    <div>
      <Table :columns="col" :data="list"></Table>
      <div class="t-right t-top-10">
        <Page
          @on-change="pageChange"
          @on-page-size-change="sizeChange"
          :total="page.total"
          show-elevator
          show-sizer
          show-total
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      col: [
        {
          title: "订单号",
          key: "order_no",
          width: 300,
        },
        {
          title: "应用信息",
          key: "order_content",
        },
        {
          title: "金额",
          key: "money",
        },
        {
          title: "支付方式",
          key: "money",
          render: (h, data) => {
            return h(
              "span",
              {},
              data.row.pay_type === 0
                ? "微信支付"
                : data.row.pay_type === 3
                ? "银行转账"
                : data.row.pay_type === 4
                ? "抵扣支付"
                : "待付款"
            );
          },
        },
        {
          title: "支付时间",
          key: "pay_time",
          render: (h, data) => {
            return h("span", {}, this.$moment(data.row.pay_time));
          },
        },
        {
        key: "enclosure",
        title: "转账凭证",
        render: (h, data) => {
          let btns = [],
            arr = data.row.pay_params.img;
          arr.map((item, index) => {
            btns.push(
              h(
                "a",
                {
                  props: {},
                  domProps: { href: item, target: "view_window" },
                  style: {
                    marginRight: "5px",
                  },
                },
                `[附件${index + 1}]`
              )
            );
          });
          return btns;
          }
        },
        {
          title: "备注",
          key: "reason",
        },
        // {
        //   title: "生效时间",
        //   key: "start_time",
        //   render: (h, data) => {
        //     return h("span", {}, data.row.status === 0 ? '-' : this.$moment(data.row.pay_time));
        //   },
        // },

        {
          title: "状态",
          key: "money",
          render: (h, data) => {
            return h(
              "span",
              {},
              data.row.status === 0 && data.row.pay_type === 3
                ? "待审核"
                : data.row.status === 0
                ? "待付款"
                : data.row.status === 1
                ? "已付款"
                : data.row.status === 2
                ? "申请退款"
                : data.row.status === 3
                ? "退款成功"
                : data.row.status === 4
                ? "退款失败"
                : data.row.status === 5
                ? "收款审核失败"
                : "已作废"
            );
          },
        },
      ],
      page: {
        p: 0,
        l: 10,
        total: 0,
      },
      list: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    ...mapActions(["GetServiceOrderData"]),
    pageChange(p) {
      this.page.p = p - 1;
      this.getList();
    },
    sizeChange(l) {
      this.page.l = l;
      this.getList();
    },
    getList() {
      this.GetServiceOrderData(this.page).then((res) => {
        this.page.total = res.total;
        this.list = res.data;
        this.list.map(item=>{
            item.pay_params = JSON.parse(item.pay_params)
        })
      });
    },
  },
  computed: mapGetters({}),
  watch: {},
};
</script>
<style lang='less'>
@import "./index.less";
</style>
